import { render, staticRenderFns } from "./ExpenseModalComponent.vue?vue&type=template&id=65aa4a3b&"
import script from "./ExpenseModalComponent.vue?vue&type=script&lang=js&"
export * from "./ExpenseModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports